import { ClientsApi } from '../../redux/api';
import Context from './index';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ClientsProvider = (props) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        axios.get(ClientsApi).then(res => setData(res.data));
    }, [setData]);

    return (
        <Context.Provider
            value={{
                ...props,
                data
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default ClientsProvider;